import * as React from "react";
import { useLocalStorage } from "@grandvisionhq/utils";
import { TRY_IN_STORE_MAX_PRODUCTS } from "../../configuration/configuration/storage.js";
const useTryInStoreStorage = () => {
  const [storage, setStorage] = useLocalStorage(
    "tryInStore",
    void 0,
    (value) => value === void 0
  );
  const has = React.useCallback(
    (sku) => {
      return Boolean(storage?.find((i) => i.sku === sku));
    },
    [storage]
  );
  const add = React.useCallback(
    ({ slug, sku }) => {
      setStorage((items) => {
        if (!items?.length) {
          return [{ slug, sku }];
        }
        const hasProductInList = has(sku);
        const hasReachedProductLimit = items.length > TRY_IN_STORE_MAX_PRODUCTS - 1;
        return !hasReachedProductLimit && !hasProductInList ? [...items, { slug, sku }] : items;
      });
    },
    [setStorage, has]
  );
  const remove = React.useCallback(
    (sku) => {
      setStorage((state = []) => {
        return state.filter((i) => i.sku !== sku);
      });
    },
    [setStorage]
  );
  const clear = React.useCallback(() => {
    setStorage(void 0);
  }, [setStorage]);
  return React.useMemo(
    () => [
      storage,
      {
        add,
        clear,
        remove
      }
    ],
    [storage, add, clear, remove]
  );
};
export {
  useTryInStoreStorage
};
//# sourceMappingURL=use-try-in-store-storage.js.map
